import React from "react";

import { ReactComponent as PersonGroupIcon } from "assets/svgs/person-group-icon.svg";
import { ReactComponent as GlobeIcon } from "assets/svgs/globe-icon.svg";
import { ReactComponent as HearthIcon } from "assets/svgs/hearth-icon.svg";
import { ReactComponent as EcoIcon } from "assets/svgs/eco-icon.svg";

import * as S from "./SectionObjectives.Style";

const objectivesList = [
  {
    id: 1,
    icon: PersonGroupIcon,
    title: "Fortalecimento do posicionamento",
    description:
      "Promoção de relacionamento, valorização e reconhecimento de clientes e parceiros."
  },
  {
    id: 2,
    icon: GlobeIcon,
    title: "Presença de marca",
    description:
      "Ter a empresa presente promovendo a democratização e o acesso à cultura."
  },
  {
    id: 3,
    icon: HearthIcon,
    title: "Promoção da saúde e do esporte",
    description:
      "Viabilizar o acesso, a inclusão e a mobilidade para todos."
  },
  {
    id: 4,
    icon: EcoIcon,
    title: "Princípios ESG",
    description:
      "Promover o desenvolvimento sustentável."
  },
];

const SectionObjectives = () => {
  return (
    <S.SectionObjectivesContainer className="container">
      <S.SectionObjectivesContent>
        <S.SectionObjectivesTitle>
          Objetivos
        </S.SectionObjectivesTitle>

        <S.SectionObjectivesText>
          <p>
            Gerar maior conhecimento de marcas e/ou produtos e negócios da CNP Seguros Holding Brasil e controladas, promover experiências positivas, aproximando-se dos brasileiros, de forma a aumentar o reconhecimento, o fortalecimento, a consideração e a preferência sobre nossa marca.
          </p>
        </S.SectionObjectivesText>
      </S.SectionObjectivesContent>

      <S.SectionObjectivesContent>
        <S.SectionObjectivesTitle>
          Pilares Estratégicos
        </S.SectionObjectivesTitle>

        <S.SectionObjectivesList>
          {objectivesList.map((objectiveItem) => (
            <S.SectionObjectivesItem key={objectiveItem.id}>
              <objectiveItem.icon />

              <S.SectionObjectivesItemContent>
                <S.SectionObjectivesItemTitle>
                  {objectiveItem.title}
                </S.SectionObjectivesItemTitle>

                <S.SectionObjectivesItemDescription>
                  {objectiveItem.description}
                </S.SectionObjectivesItemDescription>
              </S.SectionObjectivesItemContent>
            </S.SectionObjectivesItem>
          ))}
        </S.SectionObjectivesList>
      </S.SectionObjectivesContent>
    </S.SectionObjectivesContainer>
  );
};

export default SectionObjectives;
